export class SettingGroup {
  id: number;
  name: string;
}
